import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=651d5643&scoped=true"
import script from "./ResourceDialog.vue?vue&type=script&lang=js"
export * from "./ResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./ResourceDialog.vue?vue&type=style&index=0&id=651d5643&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d5643",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('651d5643')) {
      api.createRecord('651d5643', component.options)
    } else {
      api.reload('651d5643', component.options)
    }
    module.hot.accept("./ResourceDialog.vue?vue&type=template&id=651d5643&scoped=true", function () {
      api.rerender('651d5643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/ResourceDialog.vue"
export default component.exports